import React from 'react';

export default function TextErrorMessage(props) {
  return <div className='text-error'>{props.children}</div>;
}
